module.exports = __webpack_public_path__ + "static/AvenirLTStd-BookOblique-972a42176be8e242b00cac1ec3d187a1.woff";